<template>
  <div class="d-flex flex-column align-center justify-center">
    <div
      class="d-flex flex-column align-center justify-center"
      style="height:500px"
    >
      <v-card width="350px" outlined elevation="7" rounded>
        <div class="triangle-down" />

        <v-card-title class="d-flex flex-column align-center justify-center">
          <span
            class="headline"
            style="z-index:1; color:white"
          >My Profile</span
          >
          <v-avatar color="orange" size="100" class="mt-4">
            <v-icon dark size="60">
              mdi-account
            </v-icon>
          </v-avatar>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row no-gutters>
              <v-col cols="10" sm="5"> Full Name </v-col>
              <v-col cols="2" sm="1"> : </v-col>
              <v-col cols="12" sm="6">
                {{ user != null ? user.fullname : "" }}
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="10" sm="5"> Username </v-col>
              <v-col cols="2" sm="1"> : </v-col>
              <v-col cols="12" sm="6">
                {{ user != null ? user.username : "" }}
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="10" sm="5"> Email </v-col>
              <v-col cols="2" sm="1"> : </v-col>
              <v-col cols="12" sm="6">
                {{ user != null ? user.email : "" }}
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="10" sm="5"> Role </v-col>
              <v-col cols="2" sm="1"> : </v-col>
              <v-col cols="12" sm="6">
                {{ user != null ? user.role : "" }}
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="10" sm="5"> Last Login </v-col>
              <v-col cols="2" sm="1"> : </v-col>
              <v-col cols="12" sm="6">
                {{
                  user != null
                    ? user.last_login_at != undefined
                      ? user.last_login_at
                      : ""
                    : ""
                }}
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
};
</script>
<style scoped>
.td1 {
  width: 35%;
  text-align: left;
  vertical-align: top;
}
.td2 {
  width: 15%;
  text-align: center;
  vertical-align: top;
}
.td3 {
  width: 50%;
  text-align: left;
  vertical-align: top;
}
.triangle-down {
  position: absolute;
  /* background-color: grey; */
  width: 0px;
  height: 0px;
  border-left: 174px solid transparent;
  border-right: 174px solid transparent;
  border-top: 125px solid grey;
}
</style>
